module.exports = __webpack_public_path__ + "static/img/liantong_active.7952935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newimg/liantong_active.png
// module id = Kl9J
// module chunks = 0